export const ALL_USERS_ACCESS_DESCRIPTION =
    'All users with access to the projects that are in this report are given access, including those added in the future.';

export const ALL_USERS_RADIO_BUTTON_LABEL = 'All users with project access';

export const INDIVIDUAL_USERS_RADIO_BUTTON_LABEL = 'Individual users';
export const INDIVIDUAL_USERS_ACCESS_DESCRIPTION =
    'Choose individuals to give access to, and manually update in the future.';

export const USER_DOES_NOT_HAVE_ACCESS_TO_PROJECTS =
    "doesn't have the access to the project data powering this report.";

export const ALL_USERS_ACCESS_WARNING =
    'This settings will apply to new colleagues who are given access to project data. Users can turn off\n' +
    '                notifications if they wish.';
